export const SquareIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="92"
      height="92"
      viewBox="0 0 92 92"
      fill="#7CFF6B"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.932 3.97044e-05H72.0617C74.6807 -0.00519273 77.2749 0.506791 79.6955 1.50661C82.1161 2.50643 84.3155 3.97441 86.1674 5.8263C88.0193 7.6782 89.4873 9.87756 90.4871 12.2982C91.4869 14.7188 91.9989 17.313 91.9937 19.932V72.0617C91.9989 74.6807 91.4869 77.2749 90.4871 79.6955C89.4873 82.1161 88.0193 84.3155 86.1674 86.1674C84.3155 88.0193 82.1161 89.4873 79.6955 90.4871C77.2749 91.4869 74.6807 91.9989 72.0617 91.9937H19.932C17.313 91.9989 14.7188 91.4869 12.2982 90.4871C9.87756 89.4873 7.6782 88.0193 5.82631 86.1674C3.97441 84.3155 2.50644 82.1161 1.50661 79.6955C0.506793 77.2749 -0.00519173 74.6807 3.9689e-05 72.0617V19.932C0.00247748 14.6465 2.10323 9.5781 5.84067 5.84067C9.5781 2.10323 14.6465 0.00247749 19.932 3.97044e-05V3.97044e-05Z" />
    </svg>
  )
}
